import { useIonRouter } from "@ionic/react";
import { RequestModel } from "model";
import { RequestType } from "pages/RequestIndex/RequestIndex";
import { createSubProfilePath } from "routes/routeData";

import { RequestCard } from "~components/Organisms/";

type RequestItemViewProps = {
  request: RequestModel;
  requestType: RequestType;
};

const RequestItemView: React.FC<RequestItemViewProps> = ({ request, requestType }) => {
  const router = useIonRouter();

  return request.isFilled() ? (
    <RequestCard
      status="FILLED"
      request={request}
      sub={{
        name: request.sub.name,
        profileImageUrl: request.sub.photo,
        onSubNameClick: () => router.push(createSubProfilePath(requestType, request.sub.id)),
      }}
      display="full"
    />
  ) : request.isCanceled() ? (
    <RequestCard status="CANCELLED" request={request} />
  ) : request.isCompleted() ? (
    <RequestCard
      status="COMPLETED"
      request={request}
      sub={{
        name: request.sub.name,
        profileImageUrl: request.sub.photo,
        onSubNameClick: () => router.push(createSubProfilePath(requestType, request.sub.id)),
      }}
      display="full"
    />
  ) : request.isConfirmationPending() ? (
    // pending - admin has requested a sub who has a conflict
    <RequestCard status="PENDING" request={request} sub={{ profileImageUrl: request.sub.photo }} />
  ) : request.poolCount >= 1 ? (
    // sub signed up for long term request and waiting for admin to choose a sub
    <RequestCard
      status="WAITLIST"
      request={request}
      waitlistSubs={request.pool.map((sub) => sub.photo)}
    />
  ) : request.isClosed() ? (
    <RequestCard status="CLOSED" request={request} />
  ) : (
    <RequestCard status="UNFILLED" request={request} />
  );
};

export default RequestItemView;
